import { useEffect } from "react";

const SITE = "https://ddsbillancourt.fr";

function setNamedMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setPropMeta(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "/", noindex = false, jsonLd = null }) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setPropMeta("og:title", title);
    setNamedMeta("twitter:title", title);
    setPropMeta("og:url", url);
    if (description) {
      setNamedMeta("description", description);
      setPropMeta("og:description", description);
      setNamedMeta("twitter:description", description);
    }
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    if (noindex) {
      setNamedMeta("robots", "noindex, nofollow");
    } else {
      const r = document.querySelector('meta[name="robots"]');
      if (r) r.remove();
    }

    let script = document.getElementById("seo-jsonld");
    if (jsonLdStr) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = jsonLdStr;
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, noindex, jsonLdStr]);

  return null;
}
